module.exports = __webpack_public_path__ + "img/page2-bg-phone.3067f6c1.png";